import api, { adminApiPrefix } from './Api';

const reminderNotificationAdminApiPrefix = `${adminApiPrefix}/reminder-notification`;

export const sendBasketReminderToUser = async (userID: number): Promise<void> =>
  api.post(`${reminderNotificationAdminApiPrefix}/basket`, { user_id: userID });
